import { Link } from 'react-router-dom';

function QuickActions() {
  const actions = [
    { path: '/admin/produtos', icon: 'box', label: 'Produtos' },
    { path: '/admin/categorias', icon: 'tags', label: 'Categorias' },
    { path: '/admin/pedidos', icon: 'shopping-cart', label: 'Pedidos' },
    { path: '/admin/promocoes', icon: 'percent', label: 'Promoções' },
  ];

  return (
    <section className="actions-section">
      <h2 className="section-title">Ações Rápidas</h2>
      <div className="actions-grid">
        {actions.map((action) => (
          <Link key={action.path} to={action.path} className="action-card">
            <i className={`fas fa-${action.icon}`}></i>
            <span>{action.label}</span>
          </Link>
        ))}
      </div>
    </section>
  );
}

export default QuickActions;

